import { apiClient } from './apiClient';
import type {
  AdminFaqDetailDto,
  CreateFaqRequestDto,
  CreateFaqResponseDto,
  FaqSuccessResponseDto,
  GetAdminFaqListResponseDto,
  GetFaqListParams,
  GetFaqListResponseDto,
  UpdateFaqRequestDto,
} from '../types/api/faq';

/*
 * 에러는 가공하지 않고 `ApiError`(status 포함)를 그대로 던진다.
 * 사용자에게 보여줄 문구는 호출 화면에서 `resolveFaqErrorMessageKey`(lib/faqErrors.ts)로 HTTP status 별 번역 문구를 선택한다.
 */

/** 자주 묻는 질문 리스트 조회 (활성화된 FAQ만, 본문 포함 / Public) */
export const getFaqList = (params: GetFaqListParams): Promise<GetFaqListResponseDto> =>
  apiClient.get<GetFaqListResponseDto>('/faq/list', { params, skipAuth: true });

/** [어드민] 자주 묻는 질문 리스트 조회 (비활성화 포함, 본문 미포함 / 어드민 권한) */
export const getAdminFaqList = (params: GetFaqListParams): Promise<GetAdminFaqListResponseDto> =>
  apiClient.get<GetAdminFaqListResponseDto>('/faq/admin/list', { params });

/** [어드민] 자주 묻는 질문 상세 조회 (비활성화 포함, ko 번역만 반환 / 어드민 권한) */
export const getAdminFaqDetail = (faqId: number): Promise<AdminFaqDetailDto> =>
  apiClient.get<AdminFaqDetailDto>(`/faq/admin/${faqId}/detail`);

/** [어드민] 자주 묻는 질문 생성 (어드민 권한) */
export const createFaq = (data: CreateFaqRequestDto): Promise<CreateFaqResponseDto> =>
  apiClient.post<CreateFaqResponseDto>('/faq', data);

/** [어드민] 자주 묻는 질문 수정 (번역 전체 교체 / 어드민 권한) */
export const updateFaq = (faqId: number, data: UpdateFaqRequestDto): Promise<FaqSuccessResponseDto> =>
  apiClient.patch<FaqSuccessResponseDto>(`/faq/${faqId}`, data);

/** [어드민] 자주 묻는 질문 삭제 (soft delete / 어드민 권한) */
export const deleteFaq = (faqId: number): Promise<FaqSuccessResponseDto> =>
  apiClient.delete<FaqSuccessResponseDto>(`/faq/${faqId}`);
